import React from "react";

function Hello() {
  return <h1>Cześć!</h1>;
}

export default Hello;